export default "__VITE_ASSET__DPAW5EdE__"